import {
  EnvironmentProviders,
  InjectionToken,
  makeEnvironmentProviders,
} from '@angular/core';

export interface AuthRoutePaths {
  readonly login: string;
  readonly forbidden: string;
  readonly home: string;
}

export const AUTH_ROUTE_PATHS = new InjectionToken<AuthRoutePaths>(
  'AUTH_ROUTE_PATHS'
);

export function provideAuthRoutePaths(
  paths: AuthRoutePaths
): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: AUTH_ROUTE_PATHS, useValue: paths },
  ]);
}
